import { render, staticRenderFns } from "./CompView.vue?vue&type=template&id=250e11e5&scoped=true"
import script from "./CompView.vue?vue&type=script&lang=js"
export * from "./CompView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250e11e5",
  null
  
)

export default component.exports